import React from 'react';
import ReactOwlCarousel from 'react-owl-carousel';
import SingleItemCR from './SingleItemCR';

const NewProduct = () => {
	const options = {
		responsive: {
			400: {
				items: 1,
			},
			600: {
				items: 2,
			},
			800: {
				items: 3,
			},
			1200: {
				items: 4,
			}
		},
	};
	return (
		<div className='block block-products-carousel' data-layout='grid-4'>
			<div className='container'>
				<div className='block-header'>
					<h3 className='block-header__title'>New Arrivals</h3>
					<div className='block-header__divider'></div>
					<ul className='block-header__groups-list'>
						<li>
							<button
								type='button'
								className='block-header__group block-header__group--active'>
								All
							</button>
						</li>
						<li>
							<button type='button' className='block-header__group'>
								Man Fashion
							</button>
						</li>
						<li>
							<button type='button' className='block-header__group'>
								Women Fashion
							</button>
						</li>
						<li>
							<button type='button' className='block-header__group'>
								Electronics
							</button>
						</li>
					</ul>
					<div className='block-header__arrows-list'>
						<button
							className='block-header__arrow block-header__arrow--left'
							type='button'>
							<svg
								xmlns='http://www.w3.org/2000/svg'
								fill='none'
								viewBox='0 0 24 24'
								strokeWidth={1.5}
								stroke='currentColor'
								style={{
									width: '14px',
								}}>
								<path
									strokeLinecap='round'
									strokeLinejoin='round'
									d='M15.75 19.5L8.25 12l7.5-7.5'
								/>
							</svg>
						</button>{' '}
						<button
							className='block-header__arrow block-header__arrow--right'
							type='button'>
							<svg
								xmlns='http://www.w3.org/2000/svg'
								fill='none'
								viewBox='0 0 24 24'
								strokeWidth={1.5}
								stroke='currentColor'
								style={{
									width: '14px',
								}}>
								<path
									strokeLinecap='round'
									strokeLinejoin='round'
									d='M8.25 4.5l7.5 7.5-7.5 7.5'
								/>
							</svg>
						</button>
					</div>
				</div>
				<div className='block-products-carousel__slider'>
					<div className='block-products-carousel__preloader'></div>
					<ReactOwlCarousel lazyLoad={true} items={4} margin={15} {...options}>
						<SingleItemCR
							title='Dummy Product 1'
							img='https://static-01.daraz.com.bd/p/a63bdb0413cb7ca90d5bd0e439515f3e.jpg'
						/>
						<SingleItemCR
							title='Dummy Product 2'
							img='https://static-01.daraz.com.bd/p/9324630ab12cd615267d23f1a61e898f.jpg'
							isHot={true}
						/>
						<SingleItemCR
							isSale={true}
							title='Dummy Product 3'
							img='https://static-01.daraz.com.bd/p/29c19ca52d0716d9df6b9bf719c4abc7.jpg'
						/>
						<SingleItemCR
							title='Dummy Product 4'
							img='https://static-01.daraz.com.bd/p/b7fccf517415baab937db73872b25056.jpg'
							isHot={true}
						/>
						<SingleItemCR
							title='Dummy Product 5'
							img='https://static-01.daraz.com.bd/p/b6475087df47dbf6c1bd00d4b430d3af.jpg'
							isSale={true}
						/>
					</ReactOwlCarousel>
				</div>
			</div>
		</div>
	);
};

export default NewProduct;
